import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// chat_settings — ตั้งค่าระบบแชท (1 record ต่อ company)
// AI provider/model/keys removed — now managed via AI Agents
// ============================================================================
export const chatSettings = sqliteTable("chat_settings", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull().unique(),
  defaultSystemPrompt: text("default_system_prompt"),
  defaultAiModeEnabled: integer("default_ai_mode_enabled").notNull().default(0),
  handoffMessage: text("handoff_message").notNull().default("กำลังโอนสายให้พนักงาน กรุณารอสักครู่ครับ"),
  welcomeMessage: text("welcome_message").notNull().default("สวัสดีครับ! ยินดีต้อนรับสู่ระบบเช่ารถ มีอะไรให้ช่วยไหมครับ?"),
  // Timestamps
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
});

export type ChatSettings = typeof chatSettings.$inferSelect;
export type NewChatSettings = typeof chatSettings.$inferInsert;
